import axios from "axios";
import React from 'react';
import {isEmpty, isString} from "./StringUtils";
import cookie from "react-cookies";
import * as CryptoJS from 'crypto-js';
import {Spin} from 'antd';
import  {createRoot} from 'react-dom/client';
import {aisinoInfoModalForEx} from "../modal/AisinoModalMethod";
import $ from "jquery";
import {getLanguage, LEGAL_NAME, LOGIN, USER_ID} from "../../source/js/common";
import store from "../../store";
import {logout} from "../../store/actions";
const commonLan = require('../../constant/js/formItemNameLabel/'+getLanguage()+'/common.js');

// axios 配置
axios.defaults.timeout = 300000; //响应时间，1分半 改为5分钟
axios.defaults.headers.post['Content-Type'] = 'application/json'; //配置请求头
axios.defaults.headers.get['Content-Type'] = 'application/json'; //配置请求头
axios.defaults.headers.delete['Content-Type'] = 'application/json'; //配置请求头
axios.defaults.headers.put['Content-Type'] = 'application/json'; //配置请求头
// 当实例创建时设置默认配置
axios.defaults.baseURL = window.g.baseURL;
axios.defaults.withCredentials = true;
let encryptConfig = false;//是否启用加密，true启用false不启用，默认不启用加密
let urlConfig = false;
//http request 拦截器
axios.interceptors.request.use((config) => {
    // config.setHeaders([
		//     // 在这里设置请求头与携带token信息
		//
        // ]);
    if (!config.url.startsWith("/")) {
        config.url='/invoice/'+config.url;
    }
    if (config.url=='/notice/aisino/attachmentManagement/previewImgById') { //取消头像缓存
        config.params  =  config.params || {};
        config.params.t = Date.parse(new Date())/1000; //添加时间戳
    }
    if(encryptConfig){
        if(config.url=="invoice/login/siteLogin" || config.url=="invoice/login/etaxLogin"){
            urlConfig=true;
            config.url = config.url+"?noEncrypt=true";
        }
        else{
            urlConfig=false;
            config.url = config.url;
            //noNeedLogin方法，不加密
            if(config.url.indexOf('noEncrypt=true')>0){
                encryptConfig=false;
            }
        }
    }
    else{
        if(config.url.indexOf("?")>0){
            config.url = config.url+"&noEncrypt=true";
        }else{
            config.url = config.url+"?noEncrypt=true";
        }

    }
    if(config.method == 'get'){
        encryptConfig = false;
    }
    //增加请求配置的loading，默认可不传，不传默认true,传false不加载loading
    if(config.loading==null || config.loading){
        const loadingDiv = document.getElementById('loading');
        if(isEmpty(loadingDiv)){
            let dom = document.createElement('div');
            dom.setAttribute('id', 'loading');
            document.body.appendChild(dom);
            // ReactDOM.render(<Spin wrapperClassName='react-loadings' size="large" tip="loading..."></Spin>, dom);
            // 创建根节点
            createRoot(dom).render(<Spin wrapperClassName='react-loadings' size="large" tip={commonLan.loading}/>);
        }
    }

    return config;
}, (error) => {
     // message.warning("Time Out");
    removeLoading();
    return Promise.reject(error);
});
function removeLoading(){
    const loadingDiv = document.getElementById('loading');
    if(loadingDiv){
        document.body.removeChild(document.getElementById('loading'));
    }
}
//http response 拦截器:返回状态判断（添加响应拦截器）
axios.interceptors.response.use(
    response => {
        // console.log("responseBack",response);
        if (response.data.code === 40008) {
            document.body.removeChild(document.getElementById('loading'));
            // 40008 说明 token 验证失败
            // 可以直接跳转到登录页面，重新登录获取 token
            // console.log("response.data.code="+response.data.code);
            window.location.reload();//刷新页面，如果该页面需要登录，则会自动跳转到登录页面
            return {
                code:12000,
                message:"Login timeout,please login again!"
            };
        }
        // console.log("**************************************************");
        // console.log("response ", response.data);
        // console.log("**************************************************");
        if(isString(response.data) && response.data.indexOf("/invoice/canvas/login3") !== -1) {
            removeLoading();
            // console.log("error");
            //删除本地cookie存储的数据，因为前后端分离了，所以后台url和前端不是同一个，所以cookie
            //也不相同，这里cookie操作的都是前端的cookie，如果后期他们部署到同一个域下，cookie就共用了，
            //这里需要考虑会不会产生影响（其实应该不会，这里的key的名字后台不会用到）。
            cookie.remove(LOGIN);
            cookie.remove(USER_ID);
            cookie.remove(LEGAL_NAME);
            cookie.remove("gridPageSizeParam");
            cookie.remove("gridSizeListParam");
            store.dispatch(logout());
            sessionStorage.setItem("verifyLogin","0");
            window.location.reload();
            // AisinoMessage.error('please login first');
            return null;
        }
        else if(isString(response.data) && response.data.indexOf("id=\"errorMsg\"")!= -1){
            removeLoading();
            const errorMsg=$(response.data).find("#errorMsg").text();
            aisinoInfoModalForEx(errorMsg,function(){
                if(response.config.businessExpFun){
                    response.config.businessExpFun(errorMsg)
                }
            });
            return null;
        }
        if(encryptConfig && !urlConfig){
            removeLoading();
            response = myDecrypt(response);
            // console.log("Decrypt response",response.data);
            return  response.data;
        }
        if(Object.prototype.toString.call(response.data)==="[object Blob]"){//获取图片流返回
            removeLoading();
            return response.data;
        }
        removeLoading();
        return  response.data.data;
    },
    error => {
        return Promise.reject(error.response) // 接口返回的错误信息
    }
);
/*AES解密*/
export function myDecrypt(result){
    // console.log("response",response);
    let tempStr = cookie.load('AOS_TOKENID_');
    tempStr = Decrypt(tempStr, CryptoJS.MD5("AOS_TOKENID_").toString().substring(0, 16));
    result = Decrypt(result.data, tempStr);
    eval("result=" + result);
    return result;
}
export function Decrypt(response,key) {
    // console.log("Decrypt before ",response);
    let C = key;
    // console.log("key",key);
    if (C) {
        let B = CryptoJS.enc.Utf8.parse(C),
            A = CryptoJS.AES.decrypt(response, B, {
                mode: CryptoJS.mode.ECB,
                padding: CryptoJS.pad.Pkcs7
            });
        // console.log("A",A);
        response = CryptoJS.enc.Utf8.stringify(A).toString();
        // console.log("Decrypt after",response);
    }
    return response;
}
// Component.prototype.$axios = axios;
export default axios;
